import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react'
import { Tooltip, Stepper, Step, StepLabel, useMediaQuery } from '@mui/material'
import { BufferService, M_SimpleTable, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_Button, M_StateActions, NavigateContext, M_Select, M_MessageBoard, M_TransferList } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import './formsTable.css'

export default function CreateDriver() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataDriver, setDataDriver] = useState(new Map())
    const [dataDangerClassDriver, setDataDangerClassDriver] = useState([])
    const [dataDriversLicense, setDataDriversLicense] = useState([])
    const [dataLicenses, setDataLicenses] = useState([])
    const [optionsDriver, setOptionsDriver] = useState([])
    const [driverId, setDriverId] = useState("")
    const [numericDriverId, setNumericDriverId] = useState(null)
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [modalRoles, setModalRoles] = useState(false)
    const [roles, setRoles] = useState([])
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [foreignKeyNames, setForeignKeyNames] = useState({})
    const bufferServiceDriver = useMemo(() => new BufferService('Driver'), [])
    const authService = useMemo(() => new BufferService("identity/register"), [])
    const { t } = useTranslation()
    const [activeStep, setActiveStep] = useState(0)
    const steps = ['InformationDriver', 'InformationCompany', 'InformationHeath', 'LisenceDriver']
    const matches = useMediaQuery("(max-width: 570px)")
    const matchesAlternative = useMediaQuery("(max-width: 1030px)")

    const columnsADR = [
        { Name: 'ADRClassification', NormalizedName: t("DangerClass"), Type: 'select', ForeignTableToPassId: 'ADRClassificationId', ForeignKeyName: 'Description', ForeignTableName: 'ADRClassification' },
        { Name: 'CertificateNumber', NormalizedName: t("CertificateNumber"), Type: 'string' },
        { Name: 'ExpirationDate', NormalizedName: t("ADRExpirationDate"), Type: 'date' }
    ]

    const optionsLicense = [
        { Label: 'Light', Value: 1 },
        { Label: 'Heavy', Value: 2 },
        { Label: 'Motorcycle', Value: 3 },
    ]

    const columnsDriversLicense = [
        { Name: 'EmissionDate', NormalizedName: t("EmissionDate"), Type: 'date' },
        { Name: 'ExpirationDate', NormalizedName: t("ExpirationDate"), Type: 'date' },
        { Name: 'LicenseType', NormalizedName: t("LicenseType"), Type: 'enum', options: optionsLicense },
        { Name: 'VehicleCategory', NormalizedName: t("VehicleCategory"), Type: 'select', ForeignTableToPassId: 'VehicleCategoryId', ForeignKeyName: 'Name', ForeignTableName: 'VehicleCategory' }

    ]

    const columnsLicenses = [
        { Name: 'ResourceLicense', NormalizedName: t("ResourceLicense"), Type: 'select', ForeignTableToPassId: 'ResourceLicenseId', ForeignKeyName: 'Name', ForeignTableName: 'ResourceLicense' },
        { Name: 'LicenseNumber', NormalizedName: t("LicenseNumber"), Type: 'string' },
        { Name: 'IssuingAuthority', NormalizedName: t("IssuingAuthority"), Type: 'string' },
        { Name: 'ExpirationDate', NormalizedName: t("ExpirationDate"), Type: 'date' }
    ]

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line
    }, [isFirstLoop, id])

    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    }, [M_State, id])

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDD = M_StateData.filter(obj => obj.key === `dataDriver`)[0]?.value
            const tempDC = M_StateData.filter(obj => obj.key === `dataDangerClassDriver`)[0]?.value
            const tempOD = M_StateData.filter(obj => obj.key === `optionsDriver`)[0]?.value
            const tempDI = M_StateData.filter(obj => obj.key === `driverId`)[0]?.value
            const tempNumericId = M_StateData.filter(obj => obj.key === `numericDriverId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempDL = M_StateData.filter(obj => obj.key === `dataLicenses`)[0]?.value
            const tempRL = M_StateData.filter(obj => obj.key === `roles`)[0]?.value
            if (tempDD || tempDC || tempOD || tempDI || tempNumericId || tempOP || tempDL || tempRL) {
                const loadedDataDriver = new Map(tempDD || [])
                setDataDriver(loadedDataDriver)
                setDataDangerClassDriver(tempDC || [])
                setOptionsDriver(tempOD || [])
                setDriverId(tempDI || "")
                setNumericDriverId(tempNumericId ?? null)
                setOperation(tempOP || "")
                setDataLicenses(tempDL || [])
                setRoles(tempRL || [])
                if (tempOD && tempDD) {
                    const initialForeignKeyNames = {}
                    const fields = Object.fromEntries(loadedDataDriver)

                    tempOD.filter(o => o.Type === 'drawerTable').forEach(elem => {
                        const displayValue = fields[elem.Name]
                        if (displayValue) {
                            initialForeignKeyNames[elem.Name] = displayValue
                        }
                    })
                    setForeignKeyNames(initialForeignKeyNames)
                }

                if (tempDD) {
                    reset(Object.fromEntries(tempDD))
                } else {
                    reset({})
                }

                ctx.setIsLoad(false)
                return
            }
        }
        getDriver()
    }

    const { handleSubmit, control, reset, formState: { errors }, getValues } = useForm({
        defaultValues: {}
    })

    const saveStateToRedux = useCallback(() => {
        const formValues = getValues()
        const combinedDataForRedux = {
            ...formValues,
            ...foreignKeyNames
        }

        const combinedDataDriverFinal = new Map(dataDriver)
        Object.entries(combinedDataForRedux).forEach(([key, value]) => {
            combinedDataDriverFinal.set(key, value)
        })

        const tempArray = [
            { key: 'optionsDriver', value: optionsDriver },
            { key: 'dataDriver', value: Array.from(combinedDataDriverFinal) },
            { key: 'dataDangerClassDriver', value: dataDangerClassDriver },
            { key: 'driverId', value: driverId },
            { key: 'numericDriverId', value: numericDriverId },
            { key: 'operation', value: operation },
            { key: 'dataLicenses', value: dataLicenses },
            { key: 'roles', value: roles }
        ]

        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))

    }, [
        id, optionsDriver, dataDriver,
        dataDangerClassDriver, driverId,
        numericDriverId,
        operation,
        dispatch,
        getValues,
        foreignKeyNames, dataLicenses, roles
    ])

    useEffect(() => {
        return () => {
            saveStateToRedux()
        }
    }, [id, saveStateToRedux])


    const getDriver = async () => {
        ctx.setIsLoad(true)
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setDriverId(getId)
        setNumericDriverId(lines.DriverId)

        let driverOptions = optionsDriver

        if (driverOptions.length === 0) {
            const responseOptions = await bufferServiceDriver.options()

            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }

            driverOptions = responseOptions.filter(option => !option.IsHiddenList)
            setOptionsDriver(driverOptions)
        }

        if (getOperation === 'edit' || getOperation === 'view') {
            const valueDataDriver = await bufferServiceDriver.getId(getId)

            if (valueDataDriver.name === 'AxiosError') {
                ctx.toastMessages('error', valueDataDriver.response.data.Errors[0], '')
                ctx2.closeTab(id)
                return
            }
            setDataDangerClassDriver(valueDataDriver.ADRCertificates)
            setDataDriversLicense(valueDataDriver.DriversLicenses)
            setDataLicenses(valueDataDriver.ResourceLicenses || [])

            const defaultFormValues = {}
            const initialForeignKeyNames = {}
            const newDataDriver = new Map(dataDriver)

            driverOptions.forEach(obj => {
                defaultFormValues[obj.Name] = valueDataDriver[obj.Name]
                newDataDriver.set(obj.Name, valueDataDriver[obj.Name])
                if (obj.IsForeignKey) {
                    const idField = obj.ForeignTableToPassId
                    const labelField = obj.Name
                    defaultFormValues[idField] = valueDataDriver[idField]
                    initialForeignKeyNames[labelField] = valueDataDriver[labelField]
                }
            })

            setDataDriver(newDataDriver)
            setForeignKeyNames(initialForeignKeyNames)
            reset(defaultFormValues)
        } else {
            reset({})
        }
        ctx.setIsLoad(false)
    }

    const onError = (errors) => {
        const errorKeys = Object.keys(errors)

        if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0]

            const failedField = optionsDriver.find(elem =>
                elem.Name === firstErrorKey ||
                (elem.IsForeignKey && elem.ForeignTableToPassId === firstErrorKey)
            )

            let fieldName = t("RequiredFieldsErrorTitle")

            if (failedField) {
                fieldName = failedField.NormalizedName
            } else {
                fieldName = firstErrorKey
            }

            ctx.toastMessages('error', fieldName, t("RequiredField"))
        }
    }

    const openModal = () => {
        setModalRoles(true)
    }

    const createDriverLogin = (data) => {
        ctx.setIsLoad(true)

        const finalData = {
            username: data?.FirstName,
            email: data?.PersonalEmail,
            password: data?.password,
            phoneNumber: data?.PersonalPhone,
            customerId: null,
            driverId: numericDriverId,
            roleId: roles.map(r => r.Id)
        }
        authService.post(finalData).then((response) => {
            if (response.name === 'AxiosError') {
                const errorMsg = response.response?.data?.Errors?.[0] || "Erro desconhecido"
                ctx.toastMessages("error", '', errorMsg)
                ctx.setIsLoad(false)
                setModalRoles(false)
                return
            }

            ctx.toastMessages("success", '', t("SuccessCreate"))
            ctx.setIsLoad(false)
            setModalRoles(false)
        }).catch(err => {
            ctx.toastMessages("error", '', "Erro de conexão")
            ctx.setIsLoad(false)
            setModalRoles(false)
        })

    }

    const submitDriver = (data) => {
        ctx.setIsLoad(true)
        const finalData = {
            ...data,
            ADRCertificates: dataDangerClassDriver,
            DriversLicenses: dataDriversLicense,
            ResourceLicenses: dataLicenses
        }

        if (operation === 'edit') {
            bufferServiceDriver.update(driverId, finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceDriver.post(finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    const createStructureADR = (value, field, index, table) => {
        if (table === 'ADR') {
            setDataDangerClassDriver(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'License') {
            setDataDriversLicense(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Licenses') {
            setDataLicenses(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        }
    }

    const headerTableADR = columnsADR.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'ADR')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'ADR')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'ADR')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'ADR')
                                }
                            }}
                            disabled={operation === 'view' || value.disable}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' || value.disable}
                            required={value.Required}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' || value.disable}
                            required={value.Required}
                        />
                    )
                }
            }
        }
    })

    const headerTableDriversLicense = columnsDriversLicense.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'License')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'License')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'License')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'License')
                                }
                            }}
                            disabled={operation === 'view' || value.disable}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'License')}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                } else if (value.Type === 'enum') {
                    return (
                        <M_Select
                            noNone
                            options={value.options?.map(elem => ({
                                label: elem.Label,
                                value: elem.Value
                            })) || []}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'License')}
                            value={line[value.Name] || ""}
                            disabled={operation === 'view' || value.disable}
                        />
                    )

                }
            }
        }
    })

    const headerLicenses = useMemo(() => columnsLicenses.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Licenses')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Licenses')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Licenses')
                                    createStructureADR('', value.ForeignTableToPassId, 'Licenses')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                            FILTER={'AllowedForDriver eq true'}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            }
        }
    }), [columnsLicenses, createStructureADR, t])

    const addDangerClass = () => {
        setDataDangerClassDriver([...dataDangerClassDriver, { Id: dataDangerClassDriver?.length && dataDangerClassDriver[dataDangerClassDriver.length - 1]?.Id + 1 || 0 }])
    }

    const addDriversLicense = () => {
        setDataDriversLicense([...dataDriversLicense, { Id: dataDriversLicense?.length && dataDriversLicense[dataDriversLicense.length - 1]?.Id + 1 || 0 }])
    }

    const addLicenses = () => {
        setDataLicenses([...dataLicenses, { Id: dataLicenses?.length && dataLicenses[dataLicenses.length - 1]?.Id + 1 || 0 }])
    }

    const deleteADR = (Id) => {
        setDataDangerClassDriver(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }

    const deleteDriverLicense = (Id) => {
        setDataDriversLicense(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }

    const deleteLicenses = useCallback((Id) => {
        setDataLicenses(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div className='divFormDriver'>
                        <div className='divDisplayFormDriver'>
                            {optionsDriver.filter(filter => filter.GroupByInfo === 'CitizenInfo').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <Controller
                                                name={elem.ForeignTableToPassId}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field: { onChange, value } }) => (
                                                    <M_DrawerTableTextField
                                                        tableLabel={elem.NormalizedName}
                                                        label={elem.NormalizedName}
                                                        required={elem.Required}
                                                        entity={elem.ForeignTableName}
                                                        value={value ?
                                                            {
                                                                [elem.ForeignTableToPassId]: value,
                                                                [elem.ForeignKeyName]: foreignKeyNames[elem.Name] || dataDriver.get(elem.Name)
                                                            } : null}
                                                        filterField={elem.ForeignKeyName}
                                                        labelFields={[elem.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                onChange(obj[elem.ForeignTableToPassId])
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: obj[elem.ForeignKeyName]
                                                                }))
                                                            } else {
                                                                onChange(null)
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: null
                                                                }))
                                                            }
                                                        }}
                                                        disabled={operation === 'view' || elem.disable}
                                                        valueField={elem.ForeignTableToPassId}
                                                        error={!!errors[elem.ForeignTableToPassId]}
                                                        helperText={errors[elem.ForeignTableToPassId] ? t("RequiredField") : ""}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <Controller
                                                name={elem.Name}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field }) => (

                                                    < M_InputTextField
                                                        {...field}
                                                        type={"text"}
                                                        label={elem.NormalizedName}
                                                        secondColor={"var(--color-red-dark)"}
                                                        required={elem.IsRequired}
                                                        error={!!errors[elem.Name]}
                                                        helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                        disabled={operation === 'view' || elem.disable}
                                                    />
                                                )}
                                            />
                                        )
                                    ) : elem.Type === 'int32' || elem.Type === 'uint32' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"number"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'datetime' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={'date'}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Name === "BioSex" ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            defaultValue={elem.EnumValues?.[0]?.Value ?? ""}
                                            render={({ field }) => (
                                                <M_Select
                                                    {...field}
                                                    noNone
                                                    label={elem.NormalizedName}
                                                    options={elem.EnumValues?.map(elem => ({
                                                        label: elem.Label,
                                                        value: elem.Value
                                                    })) || []}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            case 1:
                return (
                    <div className='divFormDriver'>
                        <div className='divDisplayFormDriver'>
                            {optionsDriver.filter(filter => filter.GroupByInfo === 'CompanyInfo').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <Controller
                                                name={elem.ForeignTableToPassId}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field: { onChange, value } }) => (
                                                    <M_DrawerTableTextField
                                                        tableLabel={elem.NormalizedName}
                                                        label={elem.NormalizedName}
                                                        required={elem.Required}
                                                        entity={elem.ForeignTableName}
                                                        value={value ?
                                                            {
                                                                [elem.ForeignTableToPassId]: value,
                                                                [elem.ForeignKeyName]: foreignKeyNames[elem.Name] || dataDriver.get(elem.Name)
                                                            } : null}
                                                        filterField={elem.ForeignKeyName}
                                                        labelFields={[elem.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                onChange(obj[elem.ForeignTableToPassId])
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: obj[elem.ForeignKeyName]
                                                                }))
                                                            } else {
                                                                onChange(null)
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: null
                                                                }))
                                                            }
                                                        }}
                                                        disabled={operation === 'view' || elem.disable}
                                                        valueField={elem.ForeignTableToPassId}
                                                        error={!!errors[elem.ForeignTableToPassId]}
                                                        helperText={errors[elem.ForeignTableToPassId] ? t("RequiredField") : ""}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <Controller
                                                name={elem.Name}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field }) => (
                                                    < M_InputTextField
                                                        {...field}
                                                        type={elem.Name === 'MorningScheduleStart' || elem.Name === 'MorningScheduleEnd' || elem.Name === 'AfternoonScheduleStart' || elem.Name === 'AfternoonScheduleEnd' ? "time" : "text"}
                                                        label={elem.NormalizedName}
                                                        secondColor={"var(--color-red-dark)"}
                                                        required={elem.IsRequired}
                                                        error={!!errors[elem.Name]}
                                                        helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                        disabled={operation === 'view' || elem.disable}
                                                    />
                                                )}
                                            />
                                        )
                                    ) : elem.Type === 'int32' || elem.Type === 'uint32' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"number"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'datetime' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={'date'}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'decimal' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"decimal"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Name === 'ScheduleType' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            defaultValue={elem.EnumValues?.[0]?.Value ?? ""}
                                            render={({ field }) => (
                                                <M_Select
                                                    {...field}
                                                    noNone
                                                    label={elem.NormalizedName}
                                                    options={elem.EnumValues?.map(elem => ({
                                                        label: elem.Label,
                                                        value: elem.Value
                                                    })) || []}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            case 2:
                return (
                    <div className='divFormDriver'>
                        <div className='divDisplayFormDriver'>
                            {optionsDriver.filter(filter => filter.GroupByInfo === 'HealthInfo').map((elem) => (
                                <div key={elem.Name}>
                                    {elem.Type === 'string' ? (
                                        elem.IsForeignKey ? (
                                            <Controller
                                                name={elem.ForeignTableToPassId}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field: { onChange, value } }) => (
                                                    <M_DrawerTableTextField
                                                        tableLabel={elem.NormalizedName}
                                                        label={elem.NormalizedName}
                                                        required={elem.Required}
                                                        entity={elem.ForeignTableName}
                                                        value={value ?
                                                            {
                                                                [elem.ForeignTableToPassId]: value,
                                                                [elem.ForeignKeyName]: foreignKeyNames[elem.Name] || dataDriver.get(elem.Name)
                                                            } : null}
                                                        filterField={elem.ForeignKeyName}
                                                        labelFields={[elem.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            if (obj) {
                                                                onChange(obj[elem.ForeignTableToPassId])
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: obj[elem.ForeignKeyName]
                                                                }))
                                                            } else {
                                                                onChange(null)
                                                                setForeignKeyNames(prev => ({
                                                                    ...prev,
                                                                    [elem.Name]: null
                                                                }))
                                                            }
                                                        }}
                                                        disabled={operation === 'view' || elem.disable}
                                                        valueField={elem.ForeignTableToPassId}
                                                        error={!!errors[elem.ForeignTableToPassId]}
                                                        helperText={errors[elem.ForeignTableToPassId] ? t("RequiredField") : ""}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            <Controller
                                                name={elem.Name}
                                                control={control}
                                                rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                                render={({ field }) => (
                                                    < M_InputTextField
                                                        {...field}
                                                        type={"text"}
                                                        label={elem.NormalizedName}
                                                        secondColor={"var(--color-red-dark)"}
                                                        required={elem.IsRequired}
                                                        error={!!errors[elem.Name]}
                                                        helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                        disabled={operation === 'view' || elem.disable}
                                                    />
                                                )}
                                            />
                                        )
                                    ) : elem.Type === 'int32' || elem.Type === 'uint32' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={"number"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Type === 'datetime' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                <M_InputTextField
                                                    {...field}
                                                    type={'date'}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    ) : elem.Name === 'MedicalClearance' ? (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            defaultValue={elem.EnumValues?.[0]?.Value ?? ""}
                                            render={({ field }) => (
                                                <M_Select
                                                    {...field}
                                                    noNone
                                                    label={elem.NormalizedName}
                                                    options={elem.EnumValues?.map(elem => ({
                                                        label: elem.Label,
                                                        value: elem.Value
                                                    })) || []}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                />
                                            )}
                                            disabled={operation === 'view' || elem.disable}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            case 3:
                return (
                    <div className='divTableADRCapacity'>
                        {/* tabela do ADR */}
                        <div className='divTableADRandCapacity'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className='divLabelName'>
                                    <img src="/icons/svgsDaNet/radioactive.svg" alt="icon" className='iconTablesCreateTrailer' />
                                    {t("DangerClass")}</div>
                                <div>
                                    <M_Button
                                        label={t("AddADR")}
                                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                            alt="save" />
                                        }
                                        borderColor={'var(--color-grey)'}
                                        onClick={addDangerClass}
                                        disabled={operation === 'view' || false}
                                    />
                                </div>
                            </div>
                            <div>
                                <M_SimpleTable
                                    columns={[
                                        ...headerTableADR,
                                        {
                                            body: (line) => {
                                                return (
                                                    <div>
                                                        <img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress' onClick={() => deleteADR(line.Id)}
                                                        />
                                                    </div>
                                                )
                                            }
                                        }
                                    ]}
                                    rows={dataDangerClassDriver}
                                />
                            </div>
                        </div>

                        {/* Tabela do Drivers License */}
                        <div className='divTableADRandCapacity'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className='divLabelName'>
                                    <img src="/icons/svgsDaNet/car.svg" alt="icon" className='iconTablesCreateTrailer' />
                                    {t("DriversLicense")}</div>
                                <div>
                                    <M_Button
                                        label={t("AddDriversLicense")}
                                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                            alt="save" />
                                        }
                                        borderColor={'var(--color-grey)'}
                                        onClick={addDriversLicense}
                                        disabled={operation === 'view' || false}
                                    />
                                </div>
                            </div>
                            <div>
                                <M_SimpleTable
                                    columns={[
                                        ...headerTableDriversLicense,
                                        {
                                            body: (line) => {
                                                return (
                                                    <div>
                                                        <img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress' onClick={() => deleteDriverLicense(line.Id)}
                                                        />
                                                    </div>
                                                )
                                            }
                                        }
                                    ]}
                                    rows={dataDriversLicense}
                                />
                            </div>
                        </div>

                        {/* tabela das licenças */}
                        <div className='divTableADRandCapacity'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className='divLabelName'>
                                    <img src="/icons/svgsDaNet/license.svg" alt="icon" className='iconTablesCreateTrailer' />
                                    {t("TecnicalAptitude")}</div>
                                <div>
                                    <M_Button
                                        label={t("addLicense")}
                                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                            alt="save" />
                                        }
                                        borderColor={'var(--color-grey)'}
                                        onClick={addLicenses}
                                        disabled={operation === 'view' || false}
                                    />
                                </div>
                            </div>
                            <div>
                                <M_SimpleTable
                                    columns={[
                                        ...headerLicenses,
                                        {
                                            body: (line) => {
                                                return (
                                                    <div>
                                                        <img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress' onClick={() => deleteLicenses(line.Id)}
                                                        />
                                                    </div>
                                                )
                                            }
                                        }
                                    ]}
                                    rows={dataLicenses}
                                />
                            </div>
                        </div>
                    </div>
                )
            default:
                return <div>Formulário Finalizado</div>
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    {operation !== 'view' &&
                        <Tooltip title={t("Save")}>
                            <div className='iconsHeaderTable' onClick={handleSubmit(submitDriver, onError)}>
                                <i className="pi pi-save iconTable"></i>
                                <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                            </div>
                        </Tooltip>
                    }
                    {operation === 'edit' &&
                        <Tooltip title={t("Create_Credentials")}>
                            <div className='iconsHeaderTable' onClick={handleSubmit(openModal, onError)}>
                                <i className="pi pi-key iconTable"></i>
                                <span className='labelCRUDTable'><b>{"Criar Credenciais"}</b></span>
                            </div>
                        </Tooltip>
                    }
                </div>
            </div>
            <div className='dividerMenu'></div>
            <br /><br />

            <Stepper
                alternativeLabel={matchesAlternative && !matches}
                orientation={matches ? "vertical" : "horizontal"}
                activeStep={activeStep}
                sx={{
                    '& .MuiStep-root': {
                        '& .Mui-completed .MuiStepIcon-root': {
                            color: 'var(--color-red-dark)',
                        },
                        '& .Mui-completed .MuiStepConnector-line': {
                            borderColor: 'var(--color-red-dark)',
                        },
                        '& .MuiStepIcon-root.Mui-active': {
                            color: 'var(--color-red-light)'
                        }
                    },
                }}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel><b>{t(label)}</b></StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>
                <div className='divButtonsBackNext'>
                    <div className='divButtonBack'>
                        <M_Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable"></i>}
                            borderColor={'var(--color-grey)'}
                        />
                    </div>
                    <div className='divButtonNext'>
                        <M_Button
                            onClick={handleNext}
                            disabled={activeStep === steps.length - 1}
                            label={t("Next")}
                            icon={<i className="pi pi-arrow-right iconTable"></i>}
                            borderColor={'var(--color-grey)'}
                            iconPosition={'right'}
                        />
                    </div>
                </div>
                {getStepContent(activeStep)}
            </div>


            <M_MessageBoard
                open={modalRoles}
                title={t('SelectRole')}
                onClose={() => setModalRoles(false)}
                minWidth={'920px'}
                width={'min(980px, 96vw)'}
                maxWidth={'96vw'}
                body={<div style={{ width: '100%', display: 'flex', justifyContent: 'center', overflowX: 'auto' }}>
                    <M_TransferList
                        header={t("Roles")}
                        entity={'role'}
                        field={'Name'}
                        valueIdField={'Id'}
                        value={roles}
                        setValue={setRoles}
                    // filter='isExternal=true'
                    />
                </div>}
                footer={<div className='divFooterAlertsOrderService' style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <M_Button
                        backgroundColor={'var(--color-red)'}
                        label={t("Close")}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            setModalRoles(false)
                        }}
                    />
                    <M_Button
                        backgroundColor={'var(--color-green)'}
                        label={t("Save")}
                        labelColor={'var(--color-white)'}
                        onClick={handleSubmit(createDriverLogin, onError)}
                    />
                </div>}
            />

        </div>
    )
}
